const initials = "order-details/";

export const UPDATE_SINGLE_ORDER = `${initials}UPDATE_SINGLE_ORDER`;
export const UPDATE_COMMENT = `${initials}UPDATE_COMMENT`;
export const CLEAR_ORDERDETAILS = `${initials}ORDERDETAILS`;
 
